import { render, staticRenderFns } from "./PublicData.vue?vue&type=template&id=722fd274&scoped=true&"
import script from "./PublicData.vue?vue&type=script&lang=js&"
export * from "./PublicData.vue?vue&type=script&lang=js&"
import style0 from "./PublicData.vue?vue&type=style&index=0&id=722fd274&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722fd274",
  null
  
)

export default component.exports